import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/home/HomePage';

function App() {
  return (
    <LanguageProvider>
      <Home />
    </LanguageProvider>
  );
}

export default App;
